import { calculateRateCostCompound } from './compound';
import { calculateRateCostLarrain } from './larrain';
import { calculateRateCostSimple } from './simple';

export const calculateFundRateCost = (
  amount: number,
  advance: number,
  operationCostFixed: number,
  rate: number,
  days: number,
  fundCalculationHash: Record<string, string | undefined>,
  fundId?: string,
) => {
  const fundCalculationMethod = fundId
    ? fundCalculationHash[fundId] || 'SIMPLE'
    : 'SIMPLE';
  if (fundCalculationMethod === 'COMPOUND') {
    return calculateRateCostCompound(amount, advance, rate, days);
  } else if (fundCalculationMethod === 'LARRAIN') {
    return calculateRateCostLarrain(
      amount,
      advance,
      operationCostFixed,
      rate,
      days,
    );
  } else {
    return calculateRateCostSimple(amount, advance, rate, days);
  }
};
